import PropTypes from 'prop-types'
import React, { Component } from 'react'
import BannerBase from './Base'
import { fetchVersion } from 'data/config/actions'
import { connect } from 'react-redux'

import {
  Banner as ButtonAction,
  Secondary as ButtonInfo,
} from 'components/base/Button'

import MandatoryUpdateModal from 'components/Utils/MandatoryUpdateModal'

const getMajorVersion = versionString => versionString.split('.')[0]
const getMinorVersion = versionString => versionString.split('.')[1]

class BannerVersion extends Component {
  static propTypes = {
    appVersion: PropTypes.string.isRequired,
    latestVersion: PropTypes.string,
    fetchVersion: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)
    this.state = {
      seenBannerVersion: false,
    }
  }

  componentDidMount() {
    this.fetchVersionInterval = setInterval(() => {
      this.props.fetchVersion()
    }, 60000 /* 1min */)
    this.props.fetchVersion()
  }

  componentWillUnmount() {
    clearTimeout(this.fetchVersionInterval)
  }

  onClose = () => {
    this.setState({ seenBannerVersion: true })
  }

  render() {
    if (
      !this.props.latestVersion ||
      this.props.appVersion === this.props.latestVersion ||
      this.state.seenBannerVersion
    ) {
      return false
    }

    const currentMajor = getMajorVersion(this.props.appVersion)
    const latestMajor = getMajorVersion(this.props.latestVersion)

    const currentMinor = getMinorVersion(this.props.appVersion)
    const latestMinor = getMinorVersion(this.props.latestVersion)

    // Prevent display banner for patches
    if (currentMinor === latestMinor && currentMajor === latestMajor) {
      return false
    }

    // Display mandatory modal for major updates
    if (currentMajor !== latestMajor) {
      return <MandatoryUpdateModal />
    }

    // Display banner modal for minor updates
    return (
      <BannerBase onClose={this.onClose}>
        <div className="flexbox flexbox-align-center">
          <div>
            <span className="font-weight-medium font-size-large">
              A new version of Slite is available
            </span>
          </div>
          <div className="margin-left-auto flexbox">
            <ButtonInfo
              onClick={() =>
                window.open(
                  'https://slite.slite.com/p/note/eaa0f838-1935-48c7-b0dc-e34a2051ff17/Slite-Release-Notes',
                  '_blank'
                )
              }
              size="small"
              className="margin-right-normal"
            >
              What's new{' '}
            </ButtonInfo>
            <ButtonAction onClick={() => window.location.reload()} size="small">
              Reload now
            </ButtonAction>
          </div>
        </div>
      </BannerBase>
    )
  }
}

export default connect(
  state => ({
    appVersion: state.config.appVersion,
    latestVersion: state.config.latestVersion,
  }),
  { fetchVersion }
)(BannerVersion)
